import { h } from 'preact';

export default function Card({ title, actions, accent, children, ...rest }) {
  return (
    <div class={`card ${accent ? 'card-accent' : ''}`} {...rest}>
      {title && (
        <div class="card-header">
          <h3 class="card-title">{title}</h3>
          {actions && <div class="flex gap-2">{actions}</div>}
        </div>
      )}
      <div class="card-body">{children}</div>
    </div>
  );
}
